import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@shared/api/client';
import { DateRange } from '@shared/components/DateRangeFilter';

export interface StoreAnalyticsDto {
  daily: Array<{ date: string; revenue: number; orders: number }>;
  topProducts: Array<{ productId: string; name: string; qty: number; revenue: number }>;
  byStatus: Array<{ status: string; count: number }>;
  byPaymentStatus: Array<{ status: string; count: number }>;
}

export function useAnalyticsStore(range: DateRange) {
  const [from, to] = range;
  return useQuery({
    queryKey: ['analytics', 'store', from.toISOString(), to.toISOString()],
    queryFn: async () => {
      const res = await apiClient.get<StoreAnalyticsDto>('/analytics/store', {
        params: { from: from.toISOString(), to: to.toISOString() },
      });
      return res.data;
    },
  });
}
